import React from 'react';
import { debounce } from 'lodash';

interface WindowSize {
  width: number;
  height: number;
}

export const useWindowSize = (): WindowSize => {
  const [size, setSize] = React.useState<WindowSize>({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  React.useEffect(() => {
    const handleResize = debounce((): void => {
      setSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }, 150); // Only update after 150ms of no resizing

    window.addEventListener('resize', handleResize);
    return () => {
      handleResize.cancel(); // Cancel pending debounced calls
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return size;
};
